import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
	const config = useRuntimeConfig();
	const { vueApp } = nuxtApp;

	if (!config.public.sentry.dsn) {
		return;
	}

	Sentry.init({
		app: [vueApp],
		environment: import.meta.dev ? 'development' : 'production',
		dsn: config.public.sentry.dsn,

		beforeSend(event, hint) {
			const error = hint.originalException;
			if (error && error.message && error.message.match('postMessage')) {
				return null;
			}

			return event;
		},
	});
});
